
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipSailship as ObiShipSailshipElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-sailship.js';
 
 
 

 
 export const ObiShipSailship = createComponent({
   react: React,
   tagName: 'obi-ship-sailship',
   elementClass: ObiShipSailshipElement,
   events: {
     
   }
  });
 
 